export enum EndpointsLeads {
  ContractationConfig = "/contractacio/config",
  Scoring = "/leads/solvencia/:lead_id",
  DNIValidation = "/leads/dni-validation/:lead_id",
  Leads = "/leads",
  GasContractationConfig = "/gas/contractacio/config/cups/:cups",
  GasLeads = "/gas/leads"
}

export enum EndpointsProducts {
	Pricelist = "/pricelist",
	GasPricelist = "/gas/pricelist"
}